import { useMutation, useQueryClient } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const confirmationShortCloseLIQuery = async ({ formValues }) => {
  const {
    lineItemId,
    purchaseOrderId,
    level,
    remarks,
    isApproved,
    isVendor
  } = formValues;

  const payload = {
    lineItemId,
    purchaseOrderId,
    level,
    remarks,
    isApproved
  };
  const response = await axios.put(
    isVendor ? apiurl?.confirmVendorShortCloseItem : apiurl?.confirmShortCloseItem,
    payload
  );
  return response.data;
};

const confirmationShortCloseLI = () => {
  const queryClient = useQueryClient();

  return useMutation(confirmationShortCloseLIQuery, {
    onSuccess: (_, { formValues: { isVendor } }) => {
      const queryKey = isVendor ? 'getVendorPO' : 'getPO';
      queryClient.invalidateQueries(queryKey);
    }
  });
};

export default confirmationShortCloseLI;
